/**
 * App Store — NOT PRESENT in this build.
 *
 * The portfolio ships a fixed set of apps with no installable catalog, so there
 * is no App Store. This module keeps the original public surface as inert stubs
 * (`useAppStoreOptional` always returns `null`; the provider is a passthrough)
 * so the few shell components that optionally consume the store — e.g. Takeoff's
 * category grouping — compile and simply fall back to their no-catalog path.
 */
import type { ReactElement, ReactNode } from "react";

export interface AppStoreEntry {
  appId: string;
  name: string;
  description: string;
  category: string;
  icon: ReactElement;
  preInstalled: boolean;
  system?: boolean;
}

export interface AppStoreCatalogItem extends AppStoreEntry {
  isInstalled: boolean;
}

export interface AppStoreContextValue {
  catalog: AppStoreCatalogItem[];
  installApp: (appId: string) => Promise<void>;
  uninstallApp: (appId: string) => void;
  installedAppIds: Set<string>;
  isLoading: boolean;
  installingApps: Set<string>;
  recentlyInstalledApps: Set<string>;
  clearRecentlyInstalled: (appId: string) => void;
}

/** No App Store in this build — always null. */
export function useAppStoreOptional(): AppStoreContextValue | null {
  return null;
}

/** No App Store in this build — throws if a component hard-requires it. */
export function useAppStore(): AppStoreContextValue {
  throw new Error("AppStore is not available in this build");
}

/** Passthrough provider (no-op) kept for API compatibility. */
export function AppStoreProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
